module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/spikex-qr-a716ef0f98d8c3c1a9a3657b917a794b.png";